import { configureStore } from "@reduxjs/toolkit";
import CustomerReducer from "./CustomerSlice";
import EstimateReducer from "./EstimateSlice";
import ReservationReducer from "./ReservationSlice";
import CommonReducer from "./CommonSlice";
import CommunityReducer from "./CommunitySlice";

export const Store = configureStore({
    reducer : {
        customerData    : CustomerReducer,
        estimateData    : EstimateReducer,
        reservationData : ReservationReducer,
        commonData      : CommonReducer,
        communityData   : CommunityReducer,
    }
});

export type RootState = ReturnType<typeof Store.getState>;
// export type AppDispatch = typeof Store.dispatch;